// extracted by mini-css-extract-plugin
export default {"overlay":"InnerHTMLContent_overlay--Kjn","hidden":"InnerHTMLContent_hidden--c1c"};